export const MERCHANT_ENDPOINTS = {
  PROFILE: (slug: string) => `/customer/merchants/${slug}/`,
  PRODUCTS: (slug: string) => `/customer/merchants/${slug}/products/`,
  CATEGORIES: (slug: string) => `/customer/merchants/${slug}/categories/`,
  REVIEWS: (slug: string) => `/customer/merchants/${slug}/reviews/`,
  NEARBY_MERCHANTS: '/customer/nearby-merchants/',
} as const
